<template>
    <va-edit-layout>
        <ImagingServicesFeeEventFee-form
            :id="id"
            :title="title"
            :item="item"
        ></ImagingServicesFeeEventFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
